import { render, staticRenderFns } from "./CommunityEditor.vue?vue&type=template&id=2e0827cd&scoped=true&"
import script from "./CommunityEditor.vue?vue&type=script&lang=js&"
export * from "./CommunityEditor.vue?vue&type=script&lang=js&"
import style0 from "./CommunityEditor.vue?vue&type=style&index=0&id=2e0827cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0827cd",
  null
  
)

export default component.exports